import * as React from "react";
import { IInputFieldProps, SelectFieldOption, SelectFieldSchema, LoadState } from "@generation/core";
import { withRegisterFieldHoc } from "../Hoc/withRegisterFieldHoc";
import { withRenderFieldHoc } from "../Hoc/withRenderFieldHoc";
import { useFormPropsContext } from "../Context/FormPropsContextProvider";
import { DownshiftSelectField } from "./DownshiftSelectField";
import { ReactSelectField } from "./ReactSelectField";
import { SelectLibrary } from "../Interfaces/FormProps";
import classNames from "classnames";
export const RegisteredSelectField = withRegisterFieldHoc(
  withRenderFieldHoc(
    (
      props: IInputFieldProps<SelectFieldSchema> & {
        value?: any;
        onChange?: (event: any) => void;
        disabled?: boolean;
        options: SelectFieldOption[];
        loading: LoadState;
      }
    ) => {
      const formProps = useFormPropsContext();
      const cssClassNames = props.loading.toString();
      if (formProps?.fieldDefaults?.select?.library === SelectLibrary.DownShift) {
        return (
          <DownshiftSelectField
            className={cssClassNames}
            name={props.name}
            field={props.field}
            onChange={props.onChange}
            isLoading={props.loading === LoadState.loading}
            options={[
              ...props.options.map((item) => ({
                label: item.label,
                value: item.value
              }))
            ]}
            value={props.value}
          />
        );
      }
      return (
        <ReactSelectField
          className={cssClassNames}
          name={props.name}
          field={props.field}
          onChange={props.onChange}
          options={[
            ...props.options.map((item) => ({
              label: item.label,
              value: item.value
            }))
          ]}
          isLoading={props.loading === LoadState.loading}
          isDisabled={props.disabled === true}
          value={props.value}
        />
      );
    }
  )
);
